import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import * as Sentry from "@sentry/react";

// Registers the bundled resources and resolves the active language before the
// first render, so no screen paints untranslated keys.
import "@/shared/lib/i18n/index.ts";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DNS,
  integrations: [],
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
